import { apiRequestDev } from './apiRequest';

export const getAllFederalDistricts = async (config) => apiRequestDev(config, '/federal_districts/all');

export const getFederalDistrict = async (config, id) => apiRequestDev(config, `/federal_districts/user?id=${id}`);

export const assignFederalDistrict = async (config, mpId, districtId) => {
  return apiRequestDev(config, '/federal_districts/assign', 'post', {
    mp_id: mpId,
    federal_district_id: districtId,
  });
};

export const updateFederalDistrict = async (config, mpId, districtId) => {
  return apiRequestDev(config, '/federal_districts/update', 'patch', {
    mp_id: mpId,
    federal_district_id: districtId,
  });
};

export const deleteFederalDistrict = async (config, id) => apiRequestDev(config, `/federal_districts/${id}/delete`, 'delete');